export default "{\n    \"connectToQuickBooks\": \"Conectar a QuickBooks\",\n    \"connectedToQuickBooks\": \"Conectado a QuickBooks\"\n}\n"